import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { loadStoreState, setInitialStoreState } from '../../../../../common';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { DeliveryNoteItemFacade } from '../delivery-note-item.facade';
import { DeliveryNotePartiesFacade } from './delivery-note-parties.facade';
import { DeliveryNoteParams } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class DeliveryNotePartiesGuard {
  constructor(
    private deliveryNoteItemFacade: DeliveryNoteItemFacade,
    private deliveryNotePartiesFacade: DeliveryNotePartiesFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.deliveryNoteItemFacade.deliveryNoteParams$.pipe(
      switchMap((params: DeliveryNoteParams) => loadStoreState(this.deliveryNotePartiesFacade, params)),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.deliveryNotePartiesFacade);
  }
}
